import { shouldMockApis } from "./shouldMockApis";

export interface IUser {
  UserId: string;
  Name: string;
  Email: string;
  EncryptedRefreshToken: string;
  Bought: boolean;
  EmailConfirmed: boolean;
  PaymentDate?: string;
  PaymentId?: string;
  PaymentMethod?: string;
  ConfirmEmailGuid: string;
  EmailConfirmedDate?: string;
  AccountEmail: string;
  AccountType: string;
  PaymentAmount: number;
  PaymentCurrency?: string;
  IsAdmin: boolean;
  StripeCustomerId?: string;
  StripeSubscriptionId?: string;
  PartitionKey: string;
  RowKey: string;
  Timestamp: Date;
  ETag: string;
}

declare let __cloudUser__: IUser | null | undefined;

const MOCK_USER: IUser = {
  UserId: "117162129063344749731",
  Name: "jorgeaguirre1@gmail.com",
  Email: "jorgeaguirre1@gmail.com",
  EncryptedRefreshToken:
    "038189152023015127072203190205233043100201075194048152021250165188201052129202067075032237107090057177192175180077163065087087124196025192237097",
  Bought: false,
  EmailConfirmed: false,
  PaymentDate: undefined,
  PaymentId: undefined,
  PaymentMethod: undefined,
  ConfirmEmailGuid: "9e7f98b5-f6ae-4b3c-8859-82e971a81e5f",
  EmailConfirmedDate: undefined,
  AccountEmail: "jorgeaguirre1@gmail.com",
  AccountType: "Google",
  PaymentAmount: 0,
  PaymentCurrency: undefined,
  IsAdmin: true,
  PartitionKey: "UserInfo",
  RowKey: "117162129063344749731",
  Timestamp: new Date("2019-03-11T00:52:57.1416795+00:00"),
  ETag: "W/datetime'2019-03-11T00%3A52%3A57.1416795Z'",
};

export function getCurrentUser(): IUser | undefined {
  if (shouldMockApis()) {
    return MOCK_USER;
  }
  if (typeof __cloudUser__ === "undefined" || __cloudUser__ === null) {
    return undefined;
  }
  return __cloudUser__;
}

declare let __isDistributor__: boolean | undefined;

export function isDistributor(): boolean {
  if (shouldMockApis()) {
    return true;
  }
  return __isDistributor__ === true;
}

interface ICloudMetadata {
  SignInUrl: string;
  LogoutUrl: string;
  Price: number;
  PriceForDistributors: number;
  PriceRecommendedForDistributors: number;
  StripePublishableKey: string;
  PriceForDistributorsWithTaxes: number;
  SupportEmail: string;
}

declare let __cloudMetadata__: ICloudMetadata;
export function getCloudMetadata(): ICloudMetadata {
  if (shouldMockApis()) {
    return {
      SignInUrl: "https://labelmaster.azurewebsites.net",
      LogoutUrl: "https://labelmaster.azurewebsites.net",
      Price: 15,
      PriceForDistributors: 112,
      PriceRecommendedForDistributors: 160,
      StripePublishableKey: "12",
      PriceForDistributorsWithTaxes: 129.92,
      SupportEmail: "support@dinlabel.com",
    };
  }

  return __cloudMetadata__;
}

